"use client";

import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaseStudyHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [isPaused, setIsPaused] = useState(false);
  const caseStudies = [{
    id: 1,
    title: "Lagos Property Portfolio Success",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/lagos_property_portfolio_success.png"
  }, {
    id: 2,
    title: "SEO-Driven Lead Generation Campaign",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/seo_driven_lead_generation_campaign.png"
  }, {
    id: 3,
    title: "Abuja Commercial Investment Analysis",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/abuja_commercial_investment_analysis.png"
  }];
  return <section ref={ref} className="py-16 lg:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-3xl lg:text-4xl font-display font-bold text-foreground mb-4">
            Case Study Highlights
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our proven track record of transforming real estate investments and digital visibility across Nigeria.
          </p>
        </div>

        <div className={`relative max-w-5xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {caseStudies.map((study, i) => <CarouselItem key={study.id} data-index={i}>
                  <div className="relative h-[400px] lg:h-[500px] rounded-lg overflow-hidden group">
                    <img src={study.image} alt={study.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-dark-background/90 via-dark-background/40 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-8 transform transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] translate-y-2 group-hover:translate-y-0">
                      <h3 className="text-2xl lg:text-3xl font-display font-bold text-foreground-dark mb-3">
                        {study.title}
                      </h3>
                      <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]">
                        <span className="text-sm text-foreground-dark/80 font-medium">
                          View Case Study
                        </span>
                        <svg className="w-4 h-4 text-foreground-dark/80 transition-transform duration-[var(--duration-medium)] group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="left-4 lg:-left-16 hover:scale-110 transition-transform duration-[var(--duration-fast)] bg-background/90 backdrop-blur-sm border-border hover:bg-background hover:border-primary" />
            <CarouselNext className="right-4 lg:-right-16 hover:scale-110 transition-transform duration-[var(--duration-fast)] bg-background/90 backdrop-blur-sm border-border hover:bg-background hover:border-primary" />
          </Carousel>
        </div>
      </div>
    </section>;
}